import { Injectable } from '@angular/core'
import { isEmpty, isNullOrUndefined } from '@gofive/angular-common'
import { map } from 'rxjs'
import { RegisterRepository } from 'src/domain/repositories/register.repository'
import { CheckDuplicateEmailTypeEntity } from '../entities/register.entity'
import { CheckDuplicateEmailMapper } from '../mappers/register/check-duplicate-email.mapper'

@Injectable({
	providedIn: 'root',
})
export class RegisterImplementationRepository extends RegisterRepository {
	checkDuplicateEmailMapper = new CheckDuplicateEmailMapper()

	CheckDuplicateEmail(params: { email: string; currentEmail: string }) {
		let model = {
			email: params.email,
			currentEmail: isNullOrUndefined(params.currentEmail) || isEmpty(params.currentEmail) ? null : params.currentEmail,
		}
		return this.post<CheckDuplicateEmailTypeEntity>('api/v2/register/DuplicateEmail', model).pipe(
			map((response) => {
				return this.checkDuplicateEmailMapper.mapFrom(response)
			}),
		)
	}
}
